.error{font-size:12px}
/*# sourceMappingURL=component-HKDQTN6Y.css.map */
